export default [
  {
    name: 'Colombia',
    code: '57'
  },
  {
    name: 'Afganistán',
    code: '93'
  },
  {
    name: 'Albania',
    code: '355'
  },
  {
    name: 'Alemania',
    code: '49'
  },
  {
    name: 'Andorra',
    code: '376'
  },
  {
    name: 'Angola',
    code: '244'
  },
  {
    name: 'Anguila',
    code: '1 264'
  },
  {
    name: 'Antártida',
    code: '672'
  },
  {
    name: 'Antigua y Barbuda',
    code: '1 268'
  },
  {
    name: 'Arabia Saudita',
    code: '966'
  },
  {
    name: 'Argelia',
    code: '213'
  },
  {
    name: 'Argentina',
    code: '54'
  },
  {
    name: 'Armenia',
    code: '374'
  },
  {
    name: 'Aruba',
    code: '297'
  },
  {
    name: 'Australia',
    code: '61'
  },
  {
    name: 'Austria',
    code: '43'
  },
  {
    name: 'Azerbaiyán',
    code: '994'
  },
  {
    name: 'Bélgica',
    code: '32'
  },
  {
    name: 'Bahamas',
    code: '1 242'
  },
  {
    name: 'Bahrein',
    code: '973'
  },
  {
    name: 'Bangladesh',
    code: '880'
  },
  {
    name: 'Barbados',
    code: '1 246'
  },
  {
    name: 'Belice',
    code: '501'
  },
  {
    name: 'Benín',
    code: '229'
  },
  {
    name: 'Bhután',
    code: '975'
  },
  {
    name: 'Bielorrusia',
    code: '375'
  },
  {
    name: 'Birmania',
    code: '95'
  },
  {
    name: 'Bolivia',
    code: '591'
  },
  {
    name: 'Bosnia y Herzegovina',
    code: '387'
  },
  {
    name: 'Botsuana',
    code: '267'
  },
  {
    name: 'Brasil',
    code: '55'
  },
  {
    name: 'Brunéi',
    code: '673'
  },
  {
    name: 'Bulgaria',
    code: '359'
  },
  {
    name: 'Burkina Faso',
    code: '226'
  },
  {
    name: 'Burundi',
    code: '257'
  },
  {
    name: 'Cabo Verde',
    code: '238'
  },
  {
    name: 'Camboya',
    code: '855'
  },
  {
    name: 'Camerún',
    code: '237'
  },
  {
    name: 'Canadá',
    code: '1'
  },
  {
    name: 'Chad',
    code: '235'
  },
  {
    name: 'Chile',
    code: '56'
  },
  {
    name: 'China',
    code: '86'
  },
  {
    name: 'Chipre',
    code: '357'
  },
  {
    name: 'Ciudad del Vaticano',
    code: '39'
  },
  {
    name: 'Colombia',
    code: '57'
  },
  {
    name: 'Comoras',
    code: '269'
  },
  {
    name: 'República del Congo',
    code: '242'
  },
  {
    name: 'República Democrática del Congo',
    code: '243'
  },
  {
    name: 'Corea del Norte',
    code: '850'
  },
  {
    name: 'Corea del Sur',
    code: '82'
  },
  {
    name: 'Costa de Marfil',
    code: '225'
  },
  {
    name: 'Costa Rica',
    code: '506'
  },
  {
    name: 'Croacia',
    code: '385'
  },
  {
    name: 'Cuba',
    code: '53'
  },
  {
    name: 'Curazao',
    code: '5999'
  },
  {
    name: 'Dinamarca',
    code: '45'
  },
  {
    name: 'Dominica',
    code: '1 767'
  },
  {
    name: 'Ecuador',
    code: '593'
  },
  {
    name: 'Egipto',
    code: '20'
  },
  {
    name: 'El Salvador',
    code: '503'
  },
  {
    name: 'Emiratos Árabes Unidos',
    code: '971'
  },
  {
    name: 'Eritrea',
    code: '291'
  },
  {
    name: 'Eslovaquia',
    code: '421'
  },
  {
    name: 'Eslovenia',
    code: '386'
  },
  {
    name: 'España',
    code: '34'
  },
  {
    name: 'Estados Unidos de América',
    code: '1'
  },
  {
    name: 'Estonia',
    code: '372'
  },
  {
    name: 'Etiopía',
    code: '251'
  },
  {
    name: 'Filipinas',
    code: '63'
  },
  {
    name: 'Finlandia',
    code: '358'
  },
  {
    name: 'Fiyi',
    code: '679'
  },
  {
    name: 'Francia',
    code: '33'
  },
  {
    name: 'Gabón',
    code: '241'
  },
  {
    name: 'Gambia',
    code: '220'
  },
  {
    name: 'Georgia',
    code: '995'
  },
  {
    name: 'Ghana',
    code: '233'
  },
  {
    name: 'Gibraltar',
    code: '350'
  },
  {
    name: 'Granada',
    code: '1 473'
  },
  {
    name: 'Grecia',
    code: '30'
  },
  {
    name: 'Groenlandia',
    code: '299'
  },
  {
    name: 'Guadalupe',
    code: '590'
  },
  {
    name: 'Guam',
    code: '1 671'
  },
  {
    name: 'Guatemala',
    code: '502'
  },
  {
    name: 'Guayana Francesa',
    code: '594'
  },
  {
    name: 'Guernsey',
    code: '44'
  },
  {
    name: 'Guinea',
    code: '224'
  },
  {
    name: 'Guinea Ecuatorial',
    code: '240'
  },
  {
    name: 'Guinea-Bissau',
    code: '245'
  },
  {
    name: 'Guyana',
    code: '592'
  },
  {
    name: 'Haití',
    code: '509'
  },
  {
    name: 'Honduras',
    code: '504'
  },
  {
    name: 'Hong kong',
    code: '852'
  },
  {
    name: 'Hungría',
    code: '36'
  },
  {
    name: 'India',
    code: '91'
  },
  {
    name: 'Indonesia',
    code: '62'
  },
  {
    name: 'Irán',
    code: '98'
  },
  {
    name: 'Irak',
    code: '964'
  },
  {
    name: 'Irlanda',
    code: '353'
  },
  {
    name: 'Isla Bouvet',
    code: ''
  },
  {
    name: 'Isla de Man',
    code: '44'
  },
  {
    name: 'Isla de Navidad',
    code: '61'
  },
  {
    name: 'Isla Norfolk',
    code: '672'
  },
  {
    name: 'Islandia',
    code: '354'
  },
  {
    name: 'Islas Bermudas',
    code: '1 441'
  },
  {
    name: 'Islas Caimán',
    code: '1 345'
  },
  {
    name: 'Islas Cocos (Keeling)',
    code: '61'
  },
  {
    name: 'Islas Cook',
    code: '682'
  },
  {
    name: 'Islas de Åland',
    code: '358'
  },
  {
    name: 'Islas Feroe',
    code: '298'
  },
  {
    name: 'Islas Georgias del Sur y Sandwich del Sur',
    code: '500'
  },
  {
    name: 'Islas Heard y McDonald',
    code: ''
  },
  {
    name: 'Islas Maldivas',
    code: '960'
  },
  {
    name: 'Islas Malvinas',
    code: '500'
  },
  {
    name: 'Islas Marianas del Norte',
    code: '1 670'
  },
  {
    name: 'Islas Marshall',
    code: '692'
  },
  {
    name: 'Islas Pitcairn',
    code: '870'
  },
  {
    name: 'Islas Salomón',
    code: '677'
  },
  {
    name: 'Islas Turcas y Caicos',
    code: '1 649'
  },
  {
    name: 'Islas Ultramarinas Menores de Estados Unidos',
    code: '246'
  },
  {
    name: 'Islas Vírgenes Británicas',
    code: '1 284'
  },
  {
    name: 'Islas Vírgenes de los Estados Unidos',
    code: '1 340'
  },
  {
    name: 'Israel',
    code: '972'
  },
  {
    name: 'Italia',
    code: '39'
  },
  {
    name: 'Jamaica',
    code: '1 876'
  },
  {
    name: 'Japón',
    code: '81'
  },
  {
    name: 'Jersey',
    code: '44'
  },
  {
    name: 'Jordania',
    code: '962'
  },
  {
    name: 'Kazajistán',
    code: '7'
  },
  {
    name: 'Kenia',
    code: '254'
  },
  {
    name: 'Kirguistán',
    code: '996'
  },
  {
    name: 'Kiribati',
    code: '686'
  },
  {
    name: 'Kuwait',
    code: '965'
  },
  {
    name: 'Líbano',
    code: '961'
  },
  {
    name: 'Laos',
    code: '856'
  },
  {
    name: 'Lesoto',
    code: '266'
  },
  {
    name: 'Letonia',
    code: '371'
  },
  {
    name: 'Liberia',
    code: '231'
  },
  {
    name: 'Libia',
    code: '218'
  },
  {
    name: 'Liechtenstein',
    code: '423'
  },
  {
    name: 'Lituania',
    code: '370'
  },
  {
    name: 'Luxemburgo',
    code: '352'
  },
  {
    name: 'México',
    code: '52'
  },
  {
    name: 'Mónaco',
    code: '377'
  },
  {
    name: 'Macao',
    code: '853'
  },
  {
    name: 'Macedônia',
    code: '389'
  },
  {
    name: 'Madagascar',
    code: '261'
  },
  {
    name: 'Malasia',
    code: '60'
  },
  {
    name: 'Malawi',
    code: '265'
  },
  {
    name: 'Mali',
    code: '223'
  },
  {
    name: 'Malta',
    code: '356'
  },
  {
    name: 'Marruecos',
    code: '212'
  },
  {
    name: 'Martinica',
    code: '596'
  },
  {
    name: 'Mauricio',
    code: '230'
  },
  {
    name: 'Mauritania',
    code: '222'
  },
  {
    name: 'Mayotte',
    code: '262'
  },
  {
    name: 'Micronesia',
    code: '691'
  },
  {
    name: 'Moldavia',
    code: '373'
  },
  {
    name: 'Mongolia',
    code: '976'
  },
  {
    name: 'Montenegro',
    code: '382'
  },
  {
    name: 'Montserrat',
    code: '1 664'
  },
  {
    name: 'Mozambique',
    code: '258'
  },
  {
    name: 'Namibia',
    code: '264'
  },
  {
    name: 'Nauru',
    code: '674'
  },
  {
    name: 'Nepal',
    code: '977'
  },
  {
    name: 'Nicaragua',
    code: '505'
  },
  {
    name: 'Niger',
    code: '227'
  },
  {
    name: 'Nigeria',
    code: '234'
  },
  {
    name: 'Niue',
    code: '683'
  },
  {
    name: 'Noruega',
    code: '47'
  },
  {
    name: 'Nueva Caledonia',
    code: '687'
  },
  {
    name: 'Nueva Zelanda',
    code: '64'
  },
  {
    name: 'Omán',
    code: '968'
  },
  {
    name: 'Países Bajos',
    code: '31'
  },
  {
    name: 'Pakistán',
    code: '92'
  },
  {
    name: 'Palau',
    code: '680'
  },
  {
    name: 'Palestina',
    code: '970'
  },
  {
    name: 'Panamá',
    code: '507'
  },
  {
    name: 'Papúa Nueva Guinea',
    code: '675'
  },
  {
    name: 'Paraguay',
    code: '595'
  },
  {
    name: 'Perú',
    code: '51'
  },
  {
    name: 'Polinesia Francesa',
    code: '689'
  },
  {
    name: 'Polonia',
    code: '48'
  },
  {
    name: 'Portugal',
    code: '351'
  },
  {
    name: 'Puerto Rico',
    code: '1'
  },
  {
    name: 'Qatar',
    code: '974'
  },
  {
    name: 'Reino Unido',
    code: '44'
  },
  {
    name: 'República Centroafricana',
    code: '236'
  },
  {
    name: 'República Checa',
    code: '420'
  },
  {
    name: 'República Dominicana',
    code: '1 809'
  },
  {
    name: 'República de Sudán del Sur',
    code: '211'
  },
  {
    name: 'Reunión',
    code: '262'
  },
  {
    name: 'Ruanda',
    code: '250'
  },
  {
    name: 'Rumanía',
    code: '40'
  },
  {
    name: 'Rusia',
    code: '7'
  },
  {
    name: 'Sahara Occidental',
    code: '212'
  },
  {
    name: 'Samoa',
    code: '685'
  },
  {
    name: 'Samoa Americana',
    code: '1 684'
  },
  {
    name: 'San Bartolomé',
    code: '590'
  },
  {
    name: 'San Cristóbal y Nieves',
    code: '1 869'
  },
  {
    name: 'San Marino',
    code: '378'
  },
  {
    name: 'San Martín (Francia)',
    code: '1 599'
  },
  {
    name: 'San Pedro y Miquelón',
    code: '508'
  },
  {
    name: 'San Vicente y las Granadinas',
    code: '1 784'
  },
  {
    name: 'Santa Elena',
    code: '290'
  },
  {
    name: 'Santa Lucía',
    code: '1 758'
  },
  {
    name: 'Santo Tomé y Príncipe',
    code: '239'
  },
  {
    name: 'Senegal',
    code: '221'
  },
  {
    name: 'Serbia',
    code: '381'
  },
  {
    name: 'Seychelles',
    code: '248'
  },
  {
    name: 'Sierra Leona',
    code: '232'
  },
  {
    name: 'Singapur',
    code: '65'
  },
  {
    name: 'Sint Maarten',
    code: '1 721'
  },
  {
    name: 'Siria',
    code: '963'
  },
  {
    name: 'Somalia',
    code: '252'
  },
  {
    name: 'Sri lanka',
    code: '94'
  },
  {
    name: 'Sudáfrica',
    code: '27'
  },
  {
    name: 'Sudán',
    code: '249'
  },
  {
    name: 'Suecia',
    code: '46'
  },
  {
    name: 'Suiza',
    code: '41'
  },
  {
    name: 'Surinám',
    code: '597'
  },
  {
    name: 'Svalbard y Jan Mayen',
    code: '47'
  },
  {
    name: 'Swazilandia',
    code: '268'
  },
  {
    name: 'Tayikistán',
    code: '992'
  },
  {
    name: 'Tailandia',
    code: '66'
  },
  {
    name: 'Taiwán',
    code: '886'
  },
  {
    name: 'Tanzania',
    code: '255'
  },
  {
    name: 'Territorio Británico del Océano Índico',
    code: '246'
  },
  {
    name: 'Territorios Australes y Antárticas Franceses',
    code: ''
  },
  {
    name: 'Timor Oriental',
    code: '670'
  },
  {
    name: 'Togo',
    code: '228'
  },
  {
    name: 'Tokelau',
    code: '690'
  },
  {
    name: 'Tonga',
    code: '676'
  },
  {
    name: 'Trinidad y Tobago',
    code: '1 868'
  },
  {
    name: 'Tunez',
    code: '216'
  },
  {
    name: 'Turkmenistán',
    code: '993'
  },
  {
    name: 'Turquía',
    code: '90'
  },
  {
    name: 'Tuvalu',
    code: '688'
  },
  {
    name: 'Ucrania',
    code: '380'
  },
  {
    name: 'Uganda',
    code: '256'
  },
  {
    name: 'Uruguay',
    code: '598'
  },
  {
    name: 'Uzbekistán',
    code: '998'
  },
  {
    name: 'Vanuatu',
    code: '678'
  },
  {
    name: 'Venezuela',
    code: '58'
  },
  {
    name: 'Vietnam',
    code: '84'
  },
  {
    name: 'Wallis y Futuna',
    code: '681'
  },
  {
    name: 'Yemen',
    code: '967'
  },
  {
    name: 'Yibuti',
    code: '253'
  },
  {
    name: 'Zambia',
    code: '260'
  },
  {
    name: 'Zimbabue',
    code: '263' 
  }
]